import Buttons from '@ui/elements/Buttons'
import Span from '@ui/elements/Span'
import Nav from '@ui/layout/Nav'
import Div from '@ui/layout/Div'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import AdminNavigation from '@skeleton/__partials/AdminNavigation'
import { useEffect, useState } from 'react'

const Header = () => {
  const [t] = useTranslation('common')
  const { mission, logguedUser } = useSelector(state => state.main)
  const { missionLogo, missionTitle } = mission
  const [isMobile, setMobile] = useState(false)
  const navigate = useNavigate()

  const logout = () => {
    window.localStorage.removeItem('goeland_api_token')
    navigate(ROLE_PUBLIC['login'])
  }

  const childrenStart = () => {
    return (
      <Div>
        <Div cssClass='intro'>
          <Span text={missionTitle} cssClass='intro' />
        </Div>
      </Div>
    )
  }

  const updateLocal = local => {
    window.localStorage.setItem('local', local)
    window.location.reload()
  }

  const childrenEnd = () => {
    return (
      <>
        {
          null === logguedUser
            ? <></>
            : <Div cssClass='header-loggued-user'>
              <Span cssClass='logguedUser'>
                {t('labels.hello_loggued_user', { user: logguedUser.fullName })}
              </Span>
              <Buttons buttons={{ text: t('actions.logout'), cssClass: 'is-text', callback: logout }} />
            </Div>
        }
        <Div cssClass="navbar-item has-dropdown is-hoverable" >
          <a className='language navbar-link ' title={t(`labels.local`)}>{window.localStorage.getItem('local')}</a>
          <Div cssClass="navbar-dropdown">
            <a
              className={`navbar-item ${'fr' === window.localStorage.getItem('local') ? 'is-hidden' : ''}`}
              title={t('labels.french')}
              onClick={() => updateLocal('fr')}>
              {t('labels.fr')}
            </a>
            <a
              className={`navbar-item ${'en' === window.localStorage.getItem('local') ? 'is-hidden' : ''}`}
              title={t('labels.english')}
              onClick={() => updateLocal('en')}>
              {t('labels.en')}
            </a>
            <a
              className={`navbar-item ${'es' === window.localStorage.getItem('local') ? 'is-hidden' : ''}`}
              title={t('labels.spanish')}
              onClick={() => updateLocal('es')}>
              {t('labels.es')}
            </a>
          </Div>
        </Div>
      </>
    )
  }

  useEffect(() => {
    setMobile(window.innerWidth <= 768)
    window.addEventListener('resize', () => {
      setMobile(window.innerWidth <= 768)
    })
  }, [])

  return (
    <>
      <Nav
        cssClass='main-header container'
        logo={missionLogo}
        logoLink={ROLE_PUBLIC['home']}
        logoLinkLabel={t('labels.logo_link_label')}
        childrenStart={isMobile ? <></> : childrenStart()}
        isActive={true}
        withNavbarBrand={true}
        withNavbarEnd={true}
        withMenuToggle={false}
        childrenEnd={childrenEnd()}
      />
      <Div cssClass='is-hidden-tablet mobile-intro'>
        {childrenStart()}
      </Div>
      {logguedUser ? <AdminNavigation /> : <></>}
    </>
  )
}

export default Header